
const prod = {
    url: {
        FAC_URL: 'https://api.apuniversities.apcfss.in/UNVRecruitment/',
        FILE_DOWNLOAD_URL: 'https://api.apfd.apcfss.in/socialwelfaredms/user-defined-path/file-download/bucket/affiliation-documents/',


    }
};
const protocol = window.location.protocol === "https:" ? "https" : "http";
const dev = {
    url: {

        FAC_URL: 'https://swapi.dev.nidhi.apcfss.in/UNVRecruitment/', //DEV

        FILE_DOWNLOAD_URL: "https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/file-download/",
        FILE_UPLOAD_URL: `https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/file-upload/affiliation/`,


    }
};

const local = {
    url: {

        // FAC_URL: `${protocol}://172.16.119.243:8280/UNVRecruitment/`, //Pavani  /
        FAC_URL: `${protocol}://172.16.119.131:8280/UNVRecruitment/`, //Srinu  /


        // FAC_URL: 'https://swapi.dev.nidhi.apcfss.in/UNVRecruitment/', //DEV
        FILE_UPLOAD_URL: `https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/file-upload/affiliation/`,
        FILE_DOWNLOAD_URL: `https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/file-download/`,

    }

};


export const config = process.env.NODE_ENV === 'development' ? dev : prod;

